import * as types from '../type/type'

export const setLoginModalContext = (obj) => ({
  type: types.SET_LOGIN_MODAL_CONTEXT,
  payload: obj,
})
